module.exports = __webpack_public_path__ + "img/hg_medicine.a0c0c578.png";